import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS from 'reactcss';
import { Settings } from '../settings';
import Header from '../header';
import CookieToggleGroup from '../cookie-toggle-group';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import { Container } from '@ux/grid';
import Button, { Kind, Size } from '@ux/button';
import { Content } from '@ux/typeface';
import { getStyles } from '@ux/style-utils';
import { breakpointConnect } from '@ux/responsive';
import stylesheet from './InlinePrivacy.stylesheet';
import * as r from 'ramda';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinSm,
  dirty: r.pathEq([ 'form', 'dirty' ], true, props),
});

export const PureInlinePrivacy = ({
  theme,
  styles,
  isMinSm,
  isMinMd,
  cookies,
  privacyPolicyUrl,
  form,
}) => (
  <form onSubmit={form.handleSubmit}>
    <Content
      theme={theme}
      component="div"
      className="UPM__InlinePrivacy"
    >
      <style>
        {`
          .InlinePrivacy * {
            box-sizing: border-box;
          }
        `}
      </style>
      <Container
        theme={theme}
        fluid={true}
      >
        <div style={styles.header}>
          <Header
            theme={theme}
            intlNamespace="inline"
            privacyPolicyUrl={privacyPolicyUrl}
          />
          <span style={styles.save}>
            <Button
              type="submit"
              theme={theme}
              kind={Kind.POSITIVE}
              size={Size.MD}
              block={!isMinSm}
            >
              <CascadingFormattedMessage
                cascade={[
                  {
                    id: 'cookie.save',
                  },
                  {
                    id: 'cookie.confirm',
                  },
                ]}
              />
            </Button>
          </span>
        </div>
        <Settings
          theme={theme}
          expanded={true}
          isMinSm={isMinSm}
          isMinMd={isMinMd}
        >
          <CookieToggleGroup
            theme={theme}
            cookies={cookies}
            isMinMd={isMinMd}
          />
        </Settings>
      </Container>
    </Content>
  </form>
);

export const enhance = compose(
  setDisplayName('InlinePrivacy'),
  breakpointConnect([
    'isMinSm',
    'isMinMd',
  ]),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureInlinePrivacy);



// WEBPACK FOOTER //
// ./src/presentation/components/inline-privacy/InlinePrivacy.js